/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconRoad = createReactComponent("outline", "road", "IconRoad", [["path", { "d": "M4 19l4 -14", "key": "svg-0" }], ["path", { "d": "M16 5l4 14", "key": "svg-1" }], ["path", { "d": "M12 8v-2", "key": "svg-2" }], ["path", { "d": "M12 13v-2", "key": "svg-3" }], ["path", { "d": "M12 18v-2", "key": "svg-4" }]]);

export { IconRoad as default };
//# sourceMappingURL=IconRoad.mjs.map
